<template>
    <div>
            <b-row>
                <b-col cols="12" md="6">
                    <b-form-group :label="$t('class_average')">
                        <b-input-group>
                            <div class="label-as-input">{{ isNotNullValue(form.class_average) }}</div>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group :label="$t('score')">
                        <b-input-group>
                            <div class="label-as-input">{{ isNotNullValue(form.score) }}</div>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group :label="$t('letter_grade')">
                        <b-input-group>
                            <div class="label-as-input">{{ isNotNullValue(form.letter_grade) }}</div>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
    </div>
</template>

<script>
    //Service
    import RelativeGradeService from "@/services/RelativeGradeService";

    export default {
        props: {
            formId: {
                type: Number,
            }
        },
        data() {
            return {
                form: {
                    class_average: null,
                    score: null,
                    letter_grade: null,
                }
            }
        },
        async created() {
            await this.get(this.formId)
        },
        methods: {
            get(id) {
                RelativeGradeService.get(id)
                           .then((response) => {
                               this.form = response.data.data;
                           })
                           .catch((error) => {
                               this.showErrors(error)
                           });
            }
        }
    }
</script>
